/**
 * 로컬 미디어 건강 상태.
 *  - ok          : 정상
 *  - interrupted : 브리지와의 미디어 연결(ICE)이 끊김(lib CONNECTION_INTERRUPTED / ICE_FAILED)
 *  - signaling   : jitsi 시그널링(XMPP) 끊김 — lib 가 소켓 재개를 시도 중
 *  - no-data     : 카메라가 프레임을 주지 않음(캡처 정지/장치 이탈)
 *  - black       : 프레임은 흐르지만 내용이 검정(카메라 가림·가상카메라 소스 정지·잠긴 화면 공유). 자동 복구 대상 아님 — 강사 안내만
 *  - recovering  : 클라이언트가 스스로 복구(세션 재시작/재접속) 진행 중
 *  - failed      : 자가 복구 상한 도달 — 사용자 조치 필요
 */
export const MEDIA_HEALTH = {
    OK: 'ok',
    INTERRUPTED: 'interrupted',
    SIGNALING: 'signaling',
    NO_DATA: 'no-data',
    BLACK: 'black',
    RECOVERING: 'recovering',
    FAILED: 'failed',
};
/** 배지 문구. 강사(송출자)가 즉시 상황을 알고 필요하면 조치할 수 있게 한다. */
export const MEDIA_HEALTH_MESSAGE = {
    ok: '',
    interrupted: '송출 연결이 불안정합니다. 자동으로 복구를 시도합니다.',
    signaling: '서버 연결이 끊겨 다시 연결 중입니다.',
    'no-data': '카메라에서 영상이 들어오지 않습니다. 자동으로 복구를 시도합니다.',
    black: '카메라 영상이 검게 송출되고 있습니다. 카메라 가림·소스(가상카메라/화면) 상태를 확인해 주세요.',
    recovering: '송출을 복구하는 중입니다. 잠시만 기다려 주세요.',
    failed: '자동 복구에 실패했습니다. 강의실을 나갔다가 다시 입장해 주세요.',
};
